import { Module } from '../../ts/Module';
import { ISiteSettingsForSiteAdminFormScope, SiteSettingsForSiteAdminFormCtrl } from '../controllers/SiteSettingsForSiteAdminFormCtrl';

Module.instance().directive('tbSiteSettingsForSiteAdminForm',
  () => {
    return {
      restrict: 'E',
      replace: true,
      require: '^?tbSettingsCoordinator',
      templateUrl: 'siteSettingsForSiteAdminForm.html',
      link: ($scope: ISiteSettingsForSiteAdminFormScope,
        elm: JQuery,
        attrs: ng.IAttributes) => {
          $scope.localForm.formController = $scope.siteSettingsForSiteAdminForm;
          $scope.sharedForm.registerFormStateByName($scope.localForm, 'siteSettingsForSiteAdminForm');
      },
      controller: SiteSettingsForSiteAdminFormCtrl
    };
  }
);
